const defaultArgs: IdleDeadline = {
  didTimeout: false,
  timeRemaining: () => Infinity,
}

/**
 * Simple wrapper around requestIdleCallback that provides a fallback to setTimeout
 * on server-side or if requestIdleCallback is not supported.
 *
 */
export function requestIdleCallback(
  ...[cb, ...args]: Parameters<typeof window.requestIdleCallback>
) {
  if (typeof window === 'undefined') {
    // server-side, call the callback immediately
    return cb(defaultArgs)
  }

  if (window.requestIdleCallback) {
    return window.requestIdleCallback(cb, ...args)
  }

  // Fallback to setTimeout if requestIdleCallback is not supported
  // If this simple fallback is not enough, please consider using a polyfill
  return setTimeout(() => {
    cb(defaultArgs)
  }, 0)
}
